import { render } from "./JobOffersSection.vue?vue&type=template&id=35d9ab97&scoped=true"
import script from "./JobOffersSection.vue?vue&type=script&lang=js"
export * from "./JobOffersSection.vue?vue&type=script&lang=js"

import "./JobOffersSection.vue?vue&type=style&index=0&id=35d9ab97&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d9ab97"]])

export default __exports__